import React from 'react';

const TransactionIcon = ({ fill }) => {
  return (
    <svg t="1603921667716" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2859" xlink="http://www.w3.org/1999/xlink" width="15" height="15">
      <defs>
        <style type="text/css" />
      </defs>
      <path
        d="M595.8 650.8c-4.5 4.5-10.5 6.6-16.4 6.4-5.9 0.2-11.9-1.9-16.4-6.4L443.7 531.4c-8.6-8.6-8.6-22.5 0-31.1s22.5-8.6 31.1 0l104.6 104.6L684 500.3c4.4-4.4 10.2-6.5 16-6.4h96.8C787.5 340.4 667.9 225.6 512 225.6S235.5 340.4 226.3 493.8h86.3l106.6-106.6c0.7-1 1.5-2 2.5-3 4.4-4.4 10.1-6.5 15.8-6.4 5.7-0.1 11.5 2.1 15.8 6.4 0.9 0.9 1.7 1.9 2.5 3l116.4 116.4c8.6 8.6 8.6 22.5 0 31.1-8.6 8.6-22.5 8.6-31.1 0L437.5 431.2l-94 94c-3.5 7.5-11.1 12.6-19.9 12.6h-96.7C239.7 687.5 358.7 797.3 512 797.3c153.2 0 271.2-109.7 284.2-259.5h-87.5l-112.9 113z"
        fill={fill}
        p-id="2860"
       />
      <path
        d="M512 102.6c-226.1 0-409.4 183.3-409.4 409.4S285.9 921.4 512 921.4 921.4 738.1 921.4 512 738.1 102.6 512 102.6z m0 739C330 841.6 182.4 694 182.4 512c0-182 147.6-329.6 329.6-329.6 182 0 329.6 147.6 329.6 329.6 0 182-147.6 329.6-329.6 329.6z"
        fill={fill}
        p-id="2861"
       />
    </svg>
  );
};

export default TransactionIcon;
